import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

const FIELDS = [["irg_salaires", "IRG / Salaires"], ["ibs_acompte", "Acompte IBS"], ["taxe_apprentissage", "Taxe d'apprentissage"], ["tap", "TAP"], ["autres", "Autres"]];

export const G50SaisieDialog = ({ row, societeId, annee, onClose, onSaved }) => {
  const [v, setV] = useState(() => ({
    ...Object.fromEntries(FIELDS.map(([k]) => [k, row[k] || ""])),
    precompte_manuel: row.precompte_manuel ?? "",
    tva_deductible_manuel: row.tva_deductible_manuel ?? "",
  }));
  const [saving, setSaving] = useState(false);
  const num = (x) => (x === "" || x === null ? 0 : Number(x));

  const save = async () => {
    setSaving(true);
    try {
      const body = { ...Object.fromEntries(FIELDS.map(([k]) => [k, num(v[k])])), precompte_manuel: v.precompte_manuel === "" ? null : Number(v.precompte_manuel),
        tva_deductible_manuel: v.tva_deductible_manuel === "" ? null : Number(v.tva_deductible_manuel) };
      await api.put(`/g50-decl/${societeId}/${annee}/${row.mois}`, body);
      toast.success("Saisie G50 enregistrée");
      onSaved();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erreur d'enregistrement");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-card" data-testid="g50-saisie-dialog">
        <DialogHeader><DialogTitle>Saisies G50 — {row.label} {annee}</DialogTitle></DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          {FIELDS.map(([k, l]) => (
            <label key={k} className="text-xs text-muted-foreground space-y-1">{l}
              <Input type="number" step="0.01" value={v[k]} onChange={(e) => setV({ ...v, [k]: e.target.value })} data-testid={`g50-input-${k}`} />
            </label>
          ))}
          <label className="text-xs text-muted-foreground space-y-1 col-span-2">TVA déductible déclarée (laisser vide = factures d'achat : {row.tva_deductible_factures} DA)
            <Input type="number" step="0.01" value={v.tva_deductible_manuel} onChange={(e) => setV({ ...v, tva_deductible_manuel: e.target.value })} data-testid="g50-input-tva-deductible" />
          </label>
          <label className="text-xs text-muted-foreground space-y-1 col-span-2">Précompte antérieur (laisser vide = report automatique : {row.precompte_manuel == null ? row.precompte : "—"} DA)
            <Input type="number" step="0.01" value={v.precompte_manuel} onChange={(e) => setV({ ...v, precompte_manuel: e.target.value })} data-testid="g50-input-precompte" />
          </label>
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={onClose} data-testid="g50-saisie-cancel">Annuler</Button>
          <Button onClick={save} disabled={saving} data-testid="g50-saisie-save">Enregistrer</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
